/**
 * Tính chất hoạt động chi nguồn NSNN
 */
export default {
  All: 0,
  SelfControl: 5,
  NotSelfControl: 10,
};
